// The tutorial index (DEMO.md): every chapter, always available, in any order.
//
// This screen is the reason the tutorial does not feel like a corridor. There
// is no "step 4 of 20" to be trapped in the middle of — there is a list, you
// pick one, you come back. It reads the same whether or not you have an
// account; the only difference is that an account remembers which ones you
// have finished.

import { useSession } from '../data/session';
import { Cap, Surface } from '../kit';
import { Icon } from '../kit/Icon';
import { Button } from '../kit/ui';
import { useTier } from '../shell/useTier';
import { CHAPTERS, useTutorial } from './TutorialProvider';
import { SignUp, START_REASON } from './SignUp';
import '../styles/screens/hub.css';

export function TutorialIndex() {
  const { seen, enterChapter, exit } = useTutorial();
  const { session } = useSession();
  const tier = useTier();
  const columns = tier === 'phone' ? 1 : tier === 'tablet' ? 2 : 3;
  const done = CHAPTERS.filter((c) => seen.has(c.id)).length;

  return (
    <div className="fsp-screen">
      <div className="fsp-pinned">
        <div className="fsp-tutorial-head">
          <div className="fsp-grow">
            <div className="fsp-disp fsp-tutorial-title">How it works</div>
            <div className="fsp-sub fsp-ui-wrap-text">
              Eight short chapters on a league that is always mid-season. Take them in any order, as
              many times as you like — nothing you do in here is saved anywhere.
              {session && done ? ` You have finished ${done} of ${CHAPTERS.length}.` : ''}
            </div>
          </div>
          <Button size="xs" variant="quiet" icon="back" onClick={exit} hook="data-tutorial-exit">
            {session ? 'Back to my leagues' : 'Back to the front page'}
          </Button>
        </div>
      </div>

      <div className={`fsp-widgets fsp-widgets-${columns} fsp-hub-grid`}>
        {CHAPTERS.map((c, i) => (
          <Surface key={c.id} className="fsp-chapter-card">
            <button
              type="button"
              className="fsp-chapter-open"
              onClick={() => enterChapter(c.id)}
              data-chapter={c.id}
            >
              <span className="fsp-chapter-num" aria-hidden>
                {seen.has(c.id) ? <Icon name="accept" /> : i + 1}
              </span>
              <span className="fsp-grow">
                <span className="fsp-chapter-title">{c.title}</span>
                <span className="fsp-sub fsp-ui-wrap-text fsp-chapter-blurb">{c.blurb}</span>
              </span>
              <Icon name="play" />
            </button>
            <div className="fsp-chapter-foot">
              <Cap>
                {c.moments.length} {c.moments.length === 1 ? 'step' : 'steps'}
              </Cap>
              {seen.has(c.id) ? <Cap>Finished</Cap> : null}
            </div>
          </Surface>
        ))}

        <div className="fsp-hub-actions fsp-hub-span">
          {session ? (
            <Button variant="primary" icon="add" to="/leagues/new">
              Start a league
            </Button>
          ) : (
            <>
              {/* A visitor has to have an account before there is a league to
                  put friends in, so this is the only door forward from here. */}
              <SignUp label="Create an account" reason={START_REASON} />
              <Button onClick={exit}>Back to the front page</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
